import React, { useState } from "react";
import { InfiniteScroll, Toast } from 'antd-mobile';
import ListRecordView from "./ListRecordView";
import api from "../../../api";

const ListRecord = (props) => {
  const limit = 5;

  const [recordList, setRecordList] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [params, setParams] = useState({ limit })


  // 加载用户违规列表
  // https://mobile.ant.design/zh/components/infinite-scroll#%E5%B1%9E%E6%80%A7
  const loadMore = async () => {
    const resp = await api.userIllegalRecordList(params);
    const recordListData = resp.data;

    if (!recordListData) {
      setHasMore(false)
      Toast.show({ content: '加载记录出错，请稍后再试' })
      return
    }

    if (recordListData.code !== 0) {
      setHasMore(false)
      Toast.show({ content: recordListData.message })
      return
    }

    const list = recordListData.data;
    if (list.length === 0) {
      setHasMore(false)
      return
    }

    let lastId = Number.MAX_VALUE;
    list.forEach(element => {
      if (element.id < lastId) {
        lastId = element.id
      }
    });
    setParams({ lastId, limit })
    setRecordList(val => [...val, ...list])
  }


  return (
    <>
      {
        recordList.map((item, index) => (
          <ListRecordView record={item} canClick={true} key={index} />
        ))
      }

      <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
    </>
  )
}

export default ListRecord